import { loadStripe } from "@stripe/stripe-js";

// pk_test_... is safe to expose — it only lets the browser CREATE payment
// forms, never charge anything. Set it in .env (local) and as a GitHub
// Actions secret (CI), both under the same name below.
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise;

/**
 * Lazily creates (and caches) the Stripe.js load promise. Deliberately NOT
 * called at module scope — CRA bundles the whole app into one main.js with
 * no route-based code splitting, so a top-level `loadStripe()` call here
 * would fire on every single page load, not just checkout, and any load
 * failure (bad key, network block, ad blocker) would surface as a
 * blocking runtime-error overlay on totally unrelated pages. Calling this
 * from inside the checkout component instead means Stripe is only ever
 * touched when a payment form is actually about to render.
 */
export function getStripePromise() {
  if (!stripePromise) {
    if (!publishableKey) {
      // Fails loudly in dev instead of silently breaking checkout in prod.
      console.error(
        "Missing REACT_APP_STRIPE_PUBLISHABLE_KEY. Check your .env file (local) " +
        "or GitHub Actions secrets (CI build)."
      );
    }
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
}
